import React, { useEffect, useState } from 'react';
import { Box, Card, Typography, Stack, Input, Button, FormControl, FormLabel } from '@mui/joy';
import { directSupabase } from '../../../lib/supabaseClient';

export const SequenceSettingsPage: React.FC = () => {
  const [rows, setRows] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const load = async () => {
    setLoading(true);
    setError(null);
    const { data, error } = await directSupabase.from('doc_sequences').select('*, organisations(name, code)').order('updated_at', { ascending: false });
    if (error) setError(error.message);
    setRows(data || []);
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const saveRow = async (id: string, patch: any) => {
    const { error } = await directSupabase.from('doc_sequences').update(patch).eq('id', id);
    if (error) throw new Error(error.message);
  };

  return (
    <Box sx={{ 
      width: { xs: '100%', sm: '100%', md: '90%', lg: '66%' }, 
      mx: 'auto',
      px: { xs: 1, sm: 2 }
    }}>
      <Typography level="h3" sx={{ mb: 2 }}>Sequence Settings</Typography>
      {error && <Typography color="danger">{error}</Typography>}
      {rows.map(r => (
        <Card key={r.id} sx={{ p: { xs: 1.5, sm: 2 }, mb: 2 }}>
          <Typography level="title-md" sx={{ mb: 1.5 }}>{r.organisations?.name || 'Organisation'}</Typography>
          <Stack 
            direction={{ xs: 'column', sm: 'row' }} 
            spacing={2} 
            sx={{ mt: 1 }}
            alignItems={{ xs: 'stretch', sm: 'center' }}
          >
            <FormControl sx={{ flex: { xs: '1 1 100%', sm: '1 1 auto' } }}>
              <FormLabel>Prefix</FormLabel>
              <Input 
                size="sm" 
                value={r.prefix} 
                onChange={(e) => setRows(prev => prev.map(x => x.id === r.id ? { ...x, prefix: e.target.value } : x))} 
              />
            </FormControl>
            <FormControl sx={{ flex: { xs: '1 1 100%', sm: '1 1 auto' } }}>
              <FormLabel>Pad Length</FormLabel>
              <Input 
                size="sm" 
                type="number"
                value={r.pad_length} 
                onChange={(e) => setRows(prev => prev.map(x => x.id === r.id ? { ...x, pad_length: Number(e.target.value || 0) } : x))} 
              />
            </FormControl>
            <FormControl sx={{ flex: { xs: '1 1 100%', sm: '1 1 auto' } }}>
              <FormLabel>Next Number</FormLabel>
              <Input 
                size="sm" 
                type="number"
                value={r.next_number} 
                onChange={(e) => setRows(prev => prev.map(x => x.id === r.id ? { ...x, next_number: Number(e.target.value || 0) } : x))} 
              />
            </FormControl>
            <Button 
              size="sm" 
              onClick={async () => { await saveRow(r.id, { prefix: r.prefix, pad_length: r.pad_length, next_number: r.next_number }); await load(); }}
              sx={{ 
                width: { xs: '100%', sm: 'auto' },
                mt: { xs: 1, sm: 0 },
                alignSelf: { xs: 'stretch', sm: 'flex-end' }
              }}
            >
              Save
            </Button>
          </Stack>
        </Card>
      ))}
      {loading && <Typography level="body-sm">Loading…</Typography>}
    </Box>
  );
};

export default SequenceSettingsPage;

















